import { AddressValidationStatus } from "@omni/types/api/customer/cloud/shared/enums/addressValidationStatus.enum";
import { isDefined } from "@omni/utils/helper.utils";
import React, { use } from "react";

import {
    AddressFormContext,
    useAddressForm
} from "@/components/Address/AddressValidation/hooks/useAddressForm.hook";

export type ValidationAddress = {
    id?: string;
    firstName?: string;
    lastName?: string;
    companyName?: string;
    street: string;
    number: string;
    zipCode: string;
    city: string;
    country: string;
    box?: string | null;
    addressing?: string | null;
    validationStatus: AddressValidationStatus;
};

type AddressValidationProviderProps = {
    children?: React.ReactNode;
};

export const AddressValidationProvider = ({
    children
}: AddressValidationProviderProps) => {
    const {
        errorFields,
        isValidating,
        validate,
        validateBusiness,
        openAddressModal,
        AddressFormModals
    } = useAddressForm({});

    return (
        <AddressFormContext
            value={{
                errorFields,
                isValidating,
                validate,
                validateBusiness,
                openAddressModal
            }}
        >
            {AddressFormModals}
            {children}
        </AddressFormContext>
    );
};

export const useAddressValidationContext = () => {
    const context = use(AddressFormContext);

    if (!isDefined(context)) {
        throw new Error(
            "useAddressValidationContext can only be used inside AddressValidationProvider"
        );
    }

    return context;
};
